import { ModalContent } from '@app/react/dialogs/showModal';
import { t } from '@app/react/utils/i18n';
import { ErrorViewProps } from '@healthinal/react-error-utils';

export function ErrorDialog({ title, message, resetErrorBoundary }: ErrorViewProps) {
  return <ModalContent title={title} text={message} okLabel={t('Global.Ok')} onClose={() => resetErrorBoundary()} />;
}
